import { ReactNode } from 'react';

import { Span, useOnly } from '../../hooks/useBreakpoint';
import { Breakpoint } from '../../styles/media';
import { onlyStyles, onlySpan2Styles } from '../../styles/responsive.css';

interface OnlyProps {
    bp: Breakpoint;
    children: ReactNode;
    avoidRendering?: boolean;
    spans?: Span;
}

function OnlyWithMatchMedia({ bp, children, spans = 1 }: { bp: Breakpoint; children: ReactNode; spans?: Span }) {
    const matches = useOnly(bp, spans);
    return matches ? children : null;
}

export function Only({ bp, children, avoidRendering = false, spans = 1 }: OnlyProps) {
    // Use matchMedia to avoid rendering
    if (avoidRendering) {
        return (
            <OnlyWithMatchMedia bp={bp} spans={spans}>
                {children}
            </OnlyWithMatchMedia>
        );
    }

    const className = spans === 1 ? onlyStyles[bp] : onlySpan2Styles[bp];
    return <div className={className}>{children}</div>;
}
